/**
 * Turn the server-derived provenance bucket into the reviewer-facing word.
 * Provenance answers "how was this found?" (independent of the approve /
 * needs-review state, which has its own badge). Returns null when there is no
 * provenance word to show (no target found, structural skip, unknown).
 */
export function getProvenanceLabel(
  provenance: string | null | undefined,
): string | null {
  switch (provenance) {
    case "REUSED":
      return "Reused";
    case "AI_REUSED":
      return "AI Reused";
    case "AI_GENERATED":
      return "AI Generated";
    default:
      return null;
  }
}
